import { render, staticRenderFns } from "./RegistrationInfoEditTable.vue?vue&type=template&id=4f8d35d5&"
import script from "./RegistrationInfoEditTable.vue?vue&type=script&lang=ts&"
export * from "./RegistrationInfoEditTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports